import React from 'react';
import styled from 'styled-components';
import { InnerLayout } from '../../styles/Layouts';
import { Title } from '../Ui/Title';
import { techStackCategories } from '../../data/techStack';

export const TechStack = () => {
  return (
    <TechStackStyled>
      <Title title={'Tech Stack'} span={'Tech Stack'} />
      <InnerLayout>
        <div className='skills-container'>
          {techStackCategories.map((category, index) => (
            <div key={index} className='skill-category'>
              <h3 className='category-title'>{category.title}:</h3>
              <div className='skills-grid'>
                {category.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className='skill-item'>
                    <skill.icon
                      className='skill-icon'
                      style={{ color: skill.color }}
                    />
                    <span className='skill-name'>{skill.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </InnerLayout>
    </TechStackStyled>
  );
};

const TechStackStyled = styled.section`
  .skills-container {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  .skill-category {
    background: var(--background-dark-grey);
    padding: 1.5rem;
    border-radius: 10px;
    border-left: 4px solid var(--primary-color);
  }

  .category-title {
    color: var(--white-color);
    font-size: 1.2rem;
    margin-bottom: 1rem;
    font-weight: 600;
  }

  .skills-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
  }

  .skill-item {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    padding: 0.8rem;
    background: var(--background2);
    border-radius: 8px;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
  }

  .skill-icon {
    font-size: 1.5rem;
    min-width: 1.5rem;
  }

  .skill-name {
    color: var(--white-color);
    font-size: 0.9rem;
    font-weight: 500;
  }

  @media screen and (max-width: 768px) {
    .skills-grid {
      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    }

    .skill-item {
      padding: 0.6rem;
    }

    .skill-icon {
      font-size: 1.2rem;
      min-width: 1.2rem;
    }

    .skill-name {
      font-size: 0.8rem;
    }
  }
`;
